module.exports = __webpack_public_path__ + "static/Sohne-Leicht-ddefbea9eafd86a88c160d590d5df58a.woff";